import { DOC_IDS } from "@src/config/constant";
import { useRef } from "react";

function SingleUploadBox({ parentIndex, childKey, photoMeta, sectionItem, setSectionItem, showAddMore, removeFile, onUpload}: any) {
    const minUpload = photoMeta?.min_upload || 0;
      const maxUpload = photoMeta?.max_upload || 1;
  
      const fileInputRef = useRef<HTMLInputElement>(null);
  
      const openFilePicker = () => {
        fileInputRef.current?.click();
      };

      const getFileMeta = (file: any) => {
        const isFileObj = file instanceof File;
        const rawSrc = isFileObj ? file?.name : (file?.name || file?.src || file?.preview_src);
        const src = isFileObj ? URL.createObjectURL(file) : (file?.preview_src || file?.src);
        const namePart = rawSrc?.split("?")?.[0] || "";
        const ext = namePart?.split(".")?.pop()?.toLowerCase() || "";
        let fileType = ext;
        if (["csv", "xls", "xlsx"].includes(fileType)) fileType = "excel";
        if (fileType === "doc" || fileType === "docx") fileType = "word";
        return { src, fileType };
      };
  
      // Recursively find uploaded files for a specific child key
      const getChildFiles = () => {
        const parentDoc = sectionItem[parentIndex];
  
        const findFiles = (children: any[]): any[] => {
          for (const child of children) {
            if (child.value === childKey) {
              return child.uploaded_files || [];
            }
            if (child.child?.length) {
              const found = findFiles(child.child);
              if (found.length) return found;
            }
          }
          return [];
        };
  
        return findFiles(parentDoc.child);
      };
  
      const files = getChildFiles();
  
      // Recursively attach updated files to the correct child node
      const updateFiles = (newFiles: any[]) => {
        const updated = structuredClone(sectionItem);
  
        const parentDoc = updated[parentIndex];
  
        const findAndAttach = (children: any[]) => {
          for (const child of children) {
            if (child.value === childKey) {
              child.uploaded_files = newFiles;
              return true;
            }
            if (child.child?.length) {
              const found = findAndAttach(child.child);
              if (found) return true;
            }
          }
          return false;
        };
  
        findAndAttach(parentDoc.child);
        parentDoc.error_message = "";
        setSectionItem(updated);
      };
  
  
      const handleUpload = async (file: File) => {
        if (!file) return;
        if (files.length >= maxUpload) return;

        try {
          if (onUpload) {
            await onUpload(file, childKey);
          } else {
            const newFiles = [...files, file];
            updateFiles(newFiles);
          }
        } finally {
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        }
      };
  
  const HandleremoveFile = (i: number) => {
    const removedFile = files[i];
    //removeFile(removedFile);
      removeFile(i, childKey); 
    const newFiles = files.filter((_: any, idx: number) => idx !== i);
    updateFiles(newFiles);
  };
  
   
      return (
        <div className= {childKey === DOC_IDS.EXITING_POLICY ? "col-md-2  p-lg-t p-md-b": "p-lg-t p-md-b"} >
          <input ref={fileInputRef} type="file" hidden onChange={(e: any) => handleUpload(e.target.files?.[0])} />
  
          {/* Existing Files */}
          {files.map((file: any, i: number) => (
            <div key={i} className= {childKey === DOC_IDS.EXITING_POLICY ? "upload-image-proof mt-2 upload-image-proof-id": "upload-image-proof mr-3 mb-2 upload-image-proof-id"}>
              <div className="preview-box">
                <span className="close-icn" onClick={() => HandleremoveFile(i)}>
                  <i className="ic-clearclose"></i>
                </span>
                {(() => {
                  const { src, fileType } = getFileMeta(file);
                  if (fileType === "jpg" || fileType === "jpeg" || fileType === "png") {
                    return <img src={src} alt="" />;
                  }
                  return (
                    <a href={src} target="_blank" rel="noreferrer">
                      <i className={`ic-${fileType}-file f-50`}></i>
                    </a>
                  );
                })()}
              </div>
            </div>
          ))}
  
          {/* SHOW upload box ONLY when no files */}
          {files.length === 0 && (
            <div className="vehicle-upload-box mr-3 position-relative mb-2" onClick={openFilePicker} style={{ cursor: "pointer" }} >
              {photoMeta?.watermark_image && (
                <img src={photoMeta.watermark_image} className="watermark-img" alt="" />
              )}
              <span className="upload-text">Upload Photo</span>
            </div>
          )}
  
          {/* SHOW ONLY + Add More when files exist */}
          {files.length > 0 && files.length < maxUpload && showAddMore && (
            <div className="add-more-text mb-2" onClick={openFilePicker} style={{ cursor: "pointer" }}>  + Add More (optional) </div>
          )}
  
        </div>
      );
}

export default SingleUploadBox
